module.exports = __webpack_public_path__ + "img/logo_ultra.5ff714bd.jpg";